import React, { FC } from 'react';
import styles from './public_text_image_block_container.module.scss';

export const PublicTextImageBlockContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
